import { useState } from "react";
import Loader from "../Common/Loader";
import { FaAngleDown } from "react-icons/fa6";

const Section = ({
    title,
    children,
    isLoading,
    gridCols = 4,
    gridRows = 1,
    defaultOpen = true,
    innerPadding = 4,
    theme = 'green' // blue, red, green, yellow, magenta, purple, inactive
}) => {

    const [ isOpen, setIsOpen ] = useState(defaultOpen);
    
    // color mapping taken from Chip component (filled variants)
    const colors = {
        blue: { backgroundColor: '#29abe233', color: '#146c91' },
        red: { backgroundColor: '#cb383726', color: '#bc3433' },
        orange: { backgroundColor: 'rgba(255, 140, 0, 0.1)', color: '#ff8c00' }, // dark orange with 30% opacity
        green: { backgroundColor: '#28a74530', color: '#00af00' },
        yellow: { backgroundColor: '#ffcd3a33', color: '#886701' },
        magenta: { backgroundColor: '#c836c333', color: '#782075' },
        purple: { backgroundColor: '#8956ff33', color: '#290089' },
        inactive: { backgroundColor: 'rgba(234, 142, 142, 0.2)', color: 'rgba(234, 142, 142, 1)' }
    };

    const selectedTheme = colors[theme] || colors.blue;

    return (
        <>
            {
                isLoading ? (
                    <div className="w-full flex justify-center items-center border border-border rounded-md py-14 bg-white shadow">
                        <Loader />
                    </div>
                ) : (
                    <div className={`border border-primaryBg overflow-hidden bg-white shadow rounded-lg flex flex-col gap-0`}>
                        {/* header */}
                        <div
                            className="flex items-center justify-between px-4 py-2 cursor-pointer"
                            onClick={() => setIsOpen(!isOpen)}
                            style={{ backgroundColor: selectedTheme.backgroundColor }}
                        >
                            <h2 className='text-xl tracking-wide font-semibold' style={{ color: selectedTheme.color }}>{title}</h2>
                            <button className="text-sm hover:underline transition-transform duration-200" style={{ color: selectedTheme.color }}>
                                <FaAngleDown className={`size-4 transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`} style={{ color: selectedTheme.color }} />
                            </button>
                        </div>
                        {/* body */}
                        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}>
                            <div className={`gap-3 p-${innerPadding} grid grid-cols-${gridCols} grid-rows-${gridRows}`}>
                                {children}
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
}

export default Section;